import * as R from "ramda";

export const EDIT_CLASSROOM_SESSION = "EDIT_CLASSROOM_SESSION";
export const CLEAR_EDIT_CLASSROOM_SESSION = "CLEAR_EDIT_CLASSROOM_SESSION";
export const ADD_NEW_CLASSROOM = "ADD_NEW_CLASSROOM";
export const CLEAR_NEW_CLASSROOM = "CLEAR_NEW_CLASSROOM";

export const saveEditSessionData = (payload) => {
  return { type: EDIT_CLASSROOM_SESSION, payload };
};
export const addNewClassRoomFlag = (payload) => {
  return { type: ADD_NEW_CLASSROOM, payload };
};
export const clearNewClassRoomFlag = (payload) => {
  return { type: CLEAR_NEW_CLASSROOM, payload };
};

const saveEditSession = (state, action) => {
  return R.assoc("results", action.payload, state);
};

const clearEditSession = (state, action) => {
  return R.assoc("results", null, state);
};

const saveNewClassRoomFlag = (state, action) => {
  return R.assoc("results", action.payload, state);
};

const removeNewClassRoomFlag = (state, action) => {
  return R.assoc("results", action.payload, state);
};

const initialState = {
  results: null,
};

export default function editClassroomSessionReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case EDIT_CLASSROOM_SESSION: {
      return saveEditSession(state, action);
    }
    case CLEAR_EDIT_CLASSROOM_SESSION: {
      return clearEditSession(state, action);
    }
    case ADD_NEW_CLASSROOM: {
      return saveNewClassRoomFlag(state, action);
    }
    case CLEAR_NEW_CLASSROOM: {
      return removeNewClassRoomFlag(state, action);
    }
    default:
      return state;
  }
}
